import React, { useState, useEffect } from "react";
import axios from "axios";
import * as XLSX from 'xlsx';
import "./IBCommissionWithdrawHistory.css";

const IBCommissionWithdrawHistory = () => {
  const [withdrawData, setWithdrawData] = useState({
    requests: [],
    history: [],
  });
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("pending"); // pending, approved, rejected

  const FETCH_API = "https://server.majestyfx.com/admin_ib_withdraw_history.php";

  useEffect(() => {
    fetchWithdrawHistory();
  }, []);

  const fetchWithdrawHistory = async () => {
    setLoading(true);
    try {
      const response = await axios.get(FETCH_API);
      if (response.data.status) {
        setWithdrawData({
          requests: response.data.withdraw_requests || [],
          history: response.data.withdraw_history || [],
        });
      } else {
        alert("Failed to fetch withdrawal history");
      }
    } catch (error) {
      console.error("Error fetching withdrawal history:", error);
      alert("Error fetching withdrawal history. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "0":
        return <span className="status-badge pending">Pending</span>;
      case "1":
        return <span className="status-badge approved">Approved</span>;
      case "2":
        return <span className="status-badge rejected">Rejected</span>;
      default:
        return <span className="status-badge">Unknown</span>;
    }
  };

  const filterDataByStatus = () => {
    const allData = [...withdrawData.requests, ...withdrawData.history];
    
    switch (activeTab) {
      case "pending":
        return allData.filter((item) => item.status === "0" || item.Status === "0");
      case "approved":
        return allData.filter((item) => item.status === "1" || item.Status === "1");
      case "rejected":
        return allData.filter((item) => item.status === "2" || item.Status === "2");
      default:
        return allData;
    }
  };

  const exportToExcel = () => {
    const dataToExport = filterDataByStatus();
    if (dataToExport.length === 0) {
      alert('No data to export');
      return;
    }

    const exportData = dataToExport.map((item, idx) => ({
      '#': idx + 1,
      'Request ID': item.id || item.request_id,
      'IB Email': item.ib_email || item.email,
      'Amount': parseFloat(item.amount || 0).toFixed(2),
      'Payment Method': item.payment_method || item.type || '-',
      'Bank Details': item.bank_details || '-',
      'Wallet Address': item.wallet_address || '-',
      'Status': item.status === '0' || item.Status === '0' ? 'Pending' : item.status === '1' || item.Status === '1' ? 'Approved' : 'Rejected',
      'Admin Comment': item.admin_comment || '-',
      'Created At': item.created_at || item.Created_At || '-'
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'IB Commission Withdrawals');
    XLSX.writeFile(wb, `IB_Commission_Withdrawal_${activeTab}_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  const filteredData = filterDataByStatus();

  return (
    <div className="ib-withdraw-history-page">
      <div className="page-header">
        <h1>IB Commission Withdrawal History</h1>
        <div>
          <button
            className="refresh-btn"
            onClick={fetchWithdrawHistory}
            disabled={loading}
          >
            <i className="fas fa-sync-alt"></i> Refresh
          </button>
          <button
            className="excel-btn"
            onClick={exportToExcel}
            disabled={loading || filteredData.length === 0}
            style={{ marginLeft: '10px', backgroundColor: '#28a745', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            <i className="fas fa-file-excel"></i> Export to Excel
          </button>
        </div>
      </div>

      <div className="tabs-container">
        <button
          className={`tab-btn ${activeTab === "pending" ? "active" : ""}`}
          onClick={() => setActiveTab("pending")}
        >
          <i className="fas fa-clock"></i> Pending
        </button>
        <button
          className={`tab-btn ${activeTab === "approved" ? "active" : ""}`}
          onClick={() => setActiveTab("approved")}
        >
          <i className="fas fa-check-circle"></i> Approved
        </button>
        <button
          className={`tab-btn ${activeTab === "rejected" ? "active" : ""}`}
          onClick={() => setActiveTab("rejected")}
        >
          <i className="fas fa-times-circle"></i> Rejected
        </button>
      </div>

      {loading ? (
        <div className="loading-spinner">
          <i className="fas fa-spinner fa-spin"></i> Loading...
        </div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Email</th>
                <th>Amount</th>
                <th>Type</th>
                <th>Bank Details</th>
                <th>Transaction ID</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.email}</td>
                    <td className="amount">
                      ${parseFloat(item.total_commission || item.withdraw_amount || 0).toFixed(2)}
                    </td>
                    <td>{item.withdraw_type}</td>
                    <td className="bank-details">
                      <div><strong>{item.account_holder_name}</strong></div>
                      <div>{item.client_bank}</div>
                      <div>{item.account_number}</div>
                      <div>IFSC: {item.ifsc}</div>
                    </td>
                    <td className="transaction-id">
                      {item.random || item.transaction_id || "N/A"}
                    </td>
                    <td>{getStatusBadge(item.status || item.Status)}</td>
                    <td>{new Date(item.created_at || item.withdraw_date).toLocaleString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="no-data">
                    No {activeTab} withdrawal records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default IBCommissionWithdrawHistory;
